import styled from "styled-components";
import { theme } from "../theme";

export const StyledBreadcrumbs = styled.div`
	display: flex;
	flex-wrap: wrap;
	margin: 0 0 0 1rem;

	a {
		position: relative;
		text-decoration: none;
		color: ${theme.color.gray2};
		font-family: ${theme.font.secondary};
		font-weight: 500;
		font-size: 1rem;
		text-transform: initial;

		&:first-child {
			&::before {
				display: none;
			}
		}
		&::before {
			position: static;
			content: "\\00a0 / ";
		}
	}
`;
